import { useState } from "react";

import cx from "classnames";

import LoaderComponent from "@/components/ui/loader-component";

import { useWizard } from "../../context";

type Props = {
  disabled?: boolean;
  onBack?: () => void;
  onNext?: () => void;
  onSubmit?: () => Promise<void>;
  className?: string;
  text?: string;
};

export default function Buttons({ disabled, onBack, onNext, onSubmit, className, text }: Props) {
  const { state, actions } = useWizard();

  const [submitting, setSubmitting] = useState(false);

  const renderNext = () => {
    if (!state.isLast) {
      return (
        <button
          className={cx("primary px-3 py-2 text-style-body1-bold", {
            disabled: disabled,
          })}
          onClick={(e) => {
            e.preventDefault();

            if (onNext) {
              return onNext();
            }

            actions.next();
          }}
          disabled={disabled}
        >
          {text ? text : "Next"}
        </button>
      );
    }

    return (
      <button
        className={cx("primary px-3 py-2 text-style-body1-bold", {
          disabled: disabled,
          "mb-3 mb-md-0": !state.isFirst && onBack,
        })}
        onClick={async (e) => {
          e.preventDefault();

          if (onSubmit) {
            setSubmitting(true);
            return onSubmit();
          }

          actions.next();
        }}
        disabled={disabled || submitting}
      >
        {submitting ? <LoaderComponent altText="Submitting" className="mx-3" /> : "Submit"}
      </button>
    );
  };

  return (
    <div
      className={cx("d-flex flex-column-reverse flex-md-row justify-content-end mt-5", className)}
    >
      <button
        className={cx("secondary text-style-body1-bold px-3 py-2 mt-3 mt-md-0 me-md-3", {
          "d-none": state.isFirst && !onBack,
        })}
        onClick={(e) => {
          e.preventDefault();

          if (onBack) {
            return onBack();
          }

          actions.prev();
        }}
      >
        Back
      </button>

      {renderNext()}
    </div>
  );
}
